import classNames from "classnames";
import React from "react";
import ReactPlayer from "react-player";
import useWindowFocus from "../hooks/useWindowFocus";
import { fmap } from "../utils/fmap";
import { PLAY_ALT_ICON } from "../utils/svgs_new";
import { AppIcon } from "./Generic/AppIcon";
import AppSlideFadeIn from "./Generic/AppSlideFadeIn";
import { getPlayerConfig } from "./TrainingCenter/TrainingCenterVideoPlayer";

interface VideoProps {
  url: string;
  thumbnailUrl: string;
  isPlaying: boolean;
  isReplayRequested?: boolean;
  playedSeconds: number;
  onSetPlaying: (isPlay: boolean) => void;
  onSetPlayedSeconds: (seconds: number) => void;
  onEnded?: () => void;
  onError?: () => void;
}

const PopupVideo = (props: VideoProps) => {
  const { isIOSIdleForAWhile } = useWindowFocus();
  const playerRef = React.useRef<ReactPlayer>(null);
  const [isThumbnailDisplayed, setThumbnailDisplayed] = React.useState(true);
  const [isPlayerReady, setPlayerReady] = React.useState(false);

  const handleReady = () => setPlayerReady(true);

  const handleStart = () => {
    fmap(playerRef.current, (ref) => ref.seekTo(props.playedSeconds, "seconds"));
  };

  const handlePause = () => {
    props.onSetPlaying(false);
  };

  const handleProgress = (state: { played: number; playedSeconds: number }) => {
    if (state.played > 0) {
      props.onSetPlayedSeconds(state.playedSeconds);
    }
    if (isThumbnailDisplayed && state.playedSeconds > 0) {
      setThumbnailDisplayed(false);
    }
  };

  const handleError = (error: any, data?: any, hlsInstance?: any, hlsGlobal?: any) => {
    console.log({
      error: error,
      data: data,
      hlsInstance: hlsInstance,
      hlsGlobal: hlsGlobal,
    });

    if (data?.type !== "mediaError") {
      props.onError?.();
    }
  };

  const handleEnded = () => {
    props.onSetPlaying(false);
    setThumbnailDisplayed(true);
    props.onSetPlayedSeconds(0);
    props.onEnded?.();
  };

  return (
    <div className="__player-wrapper">
      <div
        className={classNames("__player-placeholder", { active: !props.isPlaying })}
        style={{
          backgroundImage: isThumbnailDisplayed ? `url(${props.thumbnailUrl})` : undefined,
        }}
      >
        <AppSlideFadeIn delay={150}>
          <div className="__player-button">
            <AppIcon icon={PLAY_ALT_ICON} className="__player-play" />
          </div>
        </AppSlideFadeIn>
      </div>
      <div className="__player-click-area" onClick={() => props.onSetPlaying(!props.isPlaying)} />
      <ReactPlayer
        ref={playerRef}
        className={classNames("__player", {
          ready: isPlayerReady,
          playing: props.isPlaying,
        })}
        url={!isIOSIdleForAWhile ? props.url : undefined}
        controls={false}
        playsinline={true}
        config={getPlayerConfig(props.thumbnailUrl)}
        playing={props.isPlaying}
        onReady={handleReady}
        onStart={handleStart}
        onPlay={handleStart}
        onPause={handlePause}
        onProgress={handleProgress}
        onError={handleError}
        onEnded={handleEnded}
        height="100%"
        width="100%"
      />
    </div>
  );
};

export default PopupVideo;
